import { DarkMode, LightMode } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useContent } from 'contexts/Content/Content';
import { useTheme } from 'contexts/Theme/Theme';

export default function HeaderControls() {
    const content = useContent();
    const theme = useTheme();

    function handleClick() {
        theme.setColorScheme(theme.darkMode ? 'light' : 'dark');
    }

    return (
        <Box sx={{
            color: content.header.foreground || '#FAAD19'
        }}>
            <IconButton aria-label={theme.darkMode ? 'Dark mode' : 'Light mode'} color="inherit" onClick={handleClick}>
                {theme.darkMode ? <DarkMode /> : <LightMode />}
            </IconButton>
        </Box>
    );
}
